<template>
  <div class="clearfix main_center" v-loading.fullscreen.lock="loading">
    <div class="top-content busWinessLeft">
      <div class="left-navbar">
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>
    <div class="right-content clearfix busWinessRight">
      <base-info :dateType="2" :projectInfo.sync="project" />
      <el-card shadow="never" class="box-card">
        <div class="monitor-video">
          <div class="monitor-video-list">
            <videoPlayer :videoUrl.sync="videoUrl" videoCode="mp4" ref="videoPlayerRef" :isShowControls="true"
              :keyIframeOffset.sync="keyIframeOffset" :ifisShowControl="true" @switchCurrentVideo="switchVideoUrl">
            </videoPlayer>
          </div>
          <placeAndEquipment ref="placeAndEquipmentRef" :roomType="openBidWitness_dataTypeObj.bidEvaluation" abTop="180px" abRight="62px"
            :currentVideo.sync="currentVideo" :videoSwitchData.sync="videoSrcData" @switchCurrentVideo="switchVideoUrl">
          </placeAndEquipment>
        </div>
      </el-card>
      <el-form ref="form" :model="form" label-width="138px" style="margin-top:12px;padding:0px 24px;" class="form">
        <div class="processStatus">
          <img src="~@/assets/images/status_record.png" v-if="form.historyid == 2">
        </div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="监督意见：" prop='superviseOpinion'>
              <el-radio-group v-model="form.superviseOpinion" disabled>
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="2">需重点关注</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="" prop='table'>
              <el-table :data="form.superviseitemList" border stripe ref="dataTable" style="width: 100%;"
                :header-cell-style="this.$globalGrayTableHeaderStyle">
                <el-table-column label="序号" prop='index' align="center" width='100' :show-overflow-tooltip='true'>
                  <div slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </div>
                </el-table-column>
                <el-table-column label="监督内容" prop='content' align="left" min-width='140'
                  :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="选项" align="center" width="150">
                  <div slot-scope="scope">
                    <el-radio :label='1' disabled v-model="scope.row.value">是</el-radio>
                    <el-radio :label='0' disabled v-model="scope.row.value">否</el-radio>
                  </div>
                </el-table-column>
                <el-table-column label="备注" prop='status' :show-overflow-tooltip='true' 
                  align="left" min-width='80'>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="监督记录：" prop='remark'>
              <el-input type="textarea" disabled :rows="5" v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="监督人：" prop='superviseMan'>
              <el-input v-model="form.superviseManName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="1">
            <el-form-item label="开标完成时间：">
              <el-date-picker v-model="form.endTime" style="width: 100%" :disabled="true" type="datetime"
                placeholder="选择时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="关键记录：">
              <el-table :data="tableDataDetail.slice((pageIndex - 1) * pageSize, pageIndex * pageSize)" border stripe
                v-loading="keyListLoading" :row-style="{ height: 60 + 'px' }" style="width: 100%">
                <el-table-column header-align="center" label="序号" width="50" type="index" align="center">
                </el-table-column>
                <el-table-column header-align="center" label="操作" width="80" align="center">
                  <template slot-scope="scope">
                    <el-button @click="confirmPosition(scope.row.timeDeviationSec, scope.$index)" type="text"
                      size="small">定位</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="recordTime" header-align="center" label="时间" width="180" align="center">
                  <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.recordTimeStr }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="快照" align="center" width='100'>
                  <template slot-scope="scope">
                    <img :src="scope.row.screenshotUrl" @click="showImgDialog(scope.row.screenshotUrl)"
                      v-if="scope.row.screenshotUrl" class="thumbnail" alt="">
                  </template>
                </el-table-column>
                <el-table-column prop="remark" header-align="center" :show-overflow-tooltip="true" label="备注">
                  <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.remark }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" hide-on-single-page
                :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="total"
                layout="total, sizes, prev, pager, next, jumper">
              </el-pagination>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="监督记录提交时间：">
              <el-input disabled v-model="form.updateTime"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog :visible.sync="imgDialogVisible" width="100%" height="100%" @closed="dialogClose">
      <img :src="dialogImageUrl" alt="" @contextmenu.prevent="" class="viewImg">
    </el-dialog>
  </div>





</template>



<script>
import videoPlayer from "@/components/videoPlayer/video";
import placeAndEquipment from "@/components/videoPlayer/placeAndEquipment";
import { bidOpenEvalWitnessSave, bidOpenEvalWitnessSubmit, getCheckItems, getWitnessRecordByCode, getWitnessRecordById, getProjectBaseInfo } from '@/server/bidOpenEvalWitness';
// import {tabsCloseCurrentHandle} from '@/utils/routeTab';
import { scrollToTop } from '@/utils/index';
import baseInfo from './components/BaseInfo.vue'
export default {
  components: {
    videoPlayer,
    placeAndEquipment,
    baseInfo
  },
  data() {
    return {
      loading: false,
      imgDialogVisible: false,
      projectListDialog: false,
      bidListDialog: false,
      keyIframeOffset: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dialogImageUrl: "",
      currentVideo: {},
      videoSrcData: [],
      videoHeight: 750,
      // videoUrl:"rtmp://58.200.131.2:1935/livetv/cctv1",
      videoUrl1: [
        {
          playUrl: "http://172.16.26.52:8080/m3u8/live/54727ae6c511e0507f181fb516491393/54727ae6c511e0507f181fb516491393_1652682600-1652689363.m3u8",
          leavel: "高清"
        }
      ],
      srcClick:0,
      videoUrl: [
        // {
        //   url:"rtmp://58.200.131.2:1935/livetv/cctv1",
        //   leavel: "高清"
        // }
      ],

      displayName: '',  //展示在页面的项目名或者标段名
      dateRange: [], //交易起止时间
      form: {    //见证数据
        id: "",          //见证数据ID
        bidopenTime: "", //开标时间
        businessId: "",  //关联的项目ID
        businessexId: "",//关联的标段ID
        createTime: "",  //创建时间
        createUser: "",  //创建人
        dataType: "1",    //见证类型     1专家抽取见证 2开标见证 3评标见证
        delFlag: false,
        detailList: [], //见证明细数据
        evalEtime: "",  //评标结束时间
        evalStime: "",  //评标开始时间
        endTime: "",//开标结束时间
        field1: "",
        field2: "",
        field3: "",
        fileTypeDictCode: "",
        fileTypeMap: {},
        historyid: "",  //-1:暂存   0:已生效
        updateTime: "", //更新时间
        updateUser: "", //更新用户
        videoEtime: "", //视频结束时间
        videoStime: "", //视频开始时间
        superviseMan: "",

        bid: { //标段数据
          id: '',//标段ID
          bidOpenRoomName: "",//开标室名称
          bidOpenRoomCode: ""//开标室CODE
        },
      },
      project: {  //项目数据
        id: "",
        bidOpenRoomName: "",
        projectCode: "",   //项目编号
        projectName: "",   //项目名称
        tenderAgencyName: "", //招标代理机构名称
        tendererName: ""   //招标人名称
      },
      tableDataDetail: [],  //明细列表
      keyListLoading: false,
      tableDataProject: [],
      tableDataBid: []
    }


  },
  computed: {

  },

  mounted() {
    this.videoHeight = document.documentElement.clientHeight < 600 ? 600 : (document.documentElement.clientHeight - 125);
  },
  activated() {
    this.bidCode = (this.$route.query && this.$route.query.bidCode) || '';
    this.form.businessType = (this.$route.query && this.$route.query.businessType) || '';
    this.form.id = (this.$route.query && this.$route.query.id) || '';
    this.getDataByIdOrCode();
    // 获取见证基本数据
    this.getBaseInfo();



    this.$nextTick(() => {
      if (this.$refs.videoPlayerRef) {
        this.$refs.videoPlayerRef.play(); // 播放
      }
    })

  },
  deactivated() {
    if (this.$refs.videoPlayerRef) {
      this.$refs.videoPlayerRef.pause();  // 暂停
    }
  },
  methods: {
    back() {
      tabsCloseCurrentHandle();
      this.$router.go(-1)
    },
    //定位视频
    confirmPosition(timeDeviationSec) {

      if(this.$refs.videoPlayerRef){
        this.$refs.videoPlayerRef.setCurrentTime(timeDeviationSec);
      }
      scrollToTop()

    },

    getBaseInfo() {
      if (this.bidCode) {
        //获取开评标见证数据项目详情
        getProjectBaseInfo({
          bidCode: this.bidCode,
          roomType: this.openBidWitness_dataTypeObj.bidOpening // 8:专家抽取室  1:开标室 2:评标室
        }).then((res) => {
          if (res.data.code == '1') {
            const data = res.data.data;
            this.project = data || {}
          }
        })
      }




    },

    dialogClose() {
      this.dialogImageUrl = "";
      this.imgDialogVisible = false;
    },
    // 图片放大弹窗
    showImgDialog(filePath) {
      this.dialogImageUrl = filePath;
      this.imgDialogVisible = true;
    },

    backBtn() { //返回
      tabsCloseCurrentHandle();
      // this.$router.push({
      //   name:'openBidAndEstimateWitness_list'
      // })
      this.$router.go(-1)

    },

    switchVideoUrl(video) {
      video.playUrl = video.playUrl ? video.playUrl : '';
      video.leavel = video.deviceName || '';
      this.currentVideo = video;
      if (!this.currentVideo.playUrl) {
        this.$message({
          type: 'error',
          message: '视频正在合成，请稍后刷新播放'
        })
      }
      this.videoUrl = this.currentVideo.playUrl ? [this.currentVideo] : [];

      // this.srcClick = this.srcClick + 1;
      // if(this.srcClick%3 == 0){
      //   this.videoUrl = [
      //     {
      //       playUrl:'http://172.16.26.52:8080/m3u8/live/2333333.m3u8'
      //     }
      //   ]
      // }
      // if(this.srcClick%3 == 1){
      //   this.videoUrl = [
      //     {
      //       playUrl:'http://172.16.26.52:8080/m3u8/live/2333333.m3u8'
      //     }
      //   ]
      // }
      // if(this.srcClick%3 == 2){
      //   this.videoUrl = [
      //     {
      //       playUrl:'http://172.16.26.52:8080/m3u8/live/2333333.m3u8'
      //     }
      //   ]
      // }

      this.getKeyIframeList();


    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
    },
    currentChangeHandle(val) {
      this.pageIndex = val
    },
    getKeyIframeList() { // 获取列表数据

      if (this.form.id && this.currentVideo.deviceCode) {
        this.keyListLoading = true;
        this.$httpReq.get(`/trading/tradingWitDetails/getByWitnessIdAndDeviceCode?parentId=${this.form.id}&deviceCode=${this.currentVideo.deviceCode}&timeDeviation=${this.currentVideo.timeDeviation || 0}`,)
          .then(res => {
            this.keyListLoading = false;
            if (res.data.code == "1") {
              this.tableDataDetail = res.data.data;
              this.pageIndex = 1;
              this.pageSize = 10;
              this.total = this.tableDataDetail.length;
              const that = this;
              var timeOffSetArr = []
              this.tableDataDetail.forEach((item) => {
                var timeDeviationSec = parseInt((new Date(item.recordTime.replace(/-/g, "/")).getTime() - new Date(item.videoStime.replace(/-/g, "/")).getTime()) / 1000) + (item.timeOffset ? parseInt(item.timeOffset) : 0);

                if (timeDeviationSec > 0) {
                  item.timeDeviationSec = timeDeviationSec || 0;
                  timeOffSetArr.push(timeDeviationSec);
                  item.recordTimeStr = that.formatterTimeDeviation(timeDeviationSec);
                } else {
                  item.recordTimeStr = '-:-:-'
                }

              })
              this.keyIframeOffset = timeOffSetArr;
            } else {
              this.tableDataDetail = [];
            }

          })
      }

    },

    formatterTimeDeviation(timeDeviationSec) {

      var hours = parseInt(timeDeviationSec / 60 / 60 % 24, 10);
      var minutes = parseInt(timeDeviationSec / 60 % 60, 10);
      var seconds = parseInt(timeDeviationSec % 60, 10);
      return (hours < 10 ? ('0' + hours) : hours) + ":" + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);

    },
   // 没有调用
    getVideoUrlList(id, bizType, roomType) {
      console.log('dddd')

      // 查询场地及场地的摄像头
      this.$httpReq.get(`/tradding/traddingwitness/getFieldsAndDevicePlayback?code=${id}&roomType=${roomType}&bizType=${bizType}`).then(res => {
        if (res.data.code === '1') {

          this.videoSrcData = res.data.data;

          if (this.videoSrcData[0] && this.videoSrcData[0].devices && this.videoSrcData[0].devices[0]) {
            const videoObj = JSON.parse(JSON.stringify(this.videoSrcData[0].devices[0]));
            videoObj.playUrl = videoObj.playUrl ? videoObj.playUrl : "";
            videoObj.leavel = videoObj.deviceName ? videoObj.deviceName : "";
            this.currentVideo = videoObj;
            if (!this.currentVideo.playUrl) {
              this.$message({
                type: 'error',
                message: '视频正在合成，请稍后刷新播放'
              })
            }
            this.$refs.placeAndEquipmentRef.setCurrentVideo(this.currentVideo);
            this.getKeyIframeList()
          }
          this.videoUrl = this.currentVideo.playUrl ? [this.currentVideo] : [];


        } else {
          this.videoSrcData = [];
          this.videoUrl = [];
        }
      })
    },



    getDataByIdOrCode() { //详情
      if (this.bidCode) {
        getWitnessRecordByCode({
          code: this.bidCode,
          dataGroup: '2', // 1:项目 2:标段 3标段组合（传项目编码）
          dataType: this.openBidWitness_dataTypeObj.bidOpening, // 8 抽取 1开标 2评标
          businessType: 'GC',
        }).then((res) => {
          const { data } = res;
          if (data.code == '1') {
            this.form = { ...data.data };
            this.form.superviseManName = this.form.superviseManName || '';
          }

          if (this.bidCode) {
            this.$refs.placeAndEquipmentRef.getFieldsAndDevicePlaybackFn({
              code: this.bidCode,
              roomType: this.openBidWitness_dataTypeObj.bidOpening,// 8:专家抽取室  1:开标室 2:评标室
              bizType: 'bid',// 业务分组 bid 或者 project
              deviceType: '', // 1桌面  2 摄像头
              tradeOrgId: '' // 交易中心id
            })
          }

        })
      } else if (this.form.id) {
        getWitnessRecordById(this.form.id).then((res) => {
          const { data } = res;
          if (data.code == '1') {
            this.form = { ...data.data };
            this.form.superviseManName = this.form.superviseManName || this.stateData.displayName;
            // this.form.superviseMan = this.form.superviseMan || this.stateData.id;
            this.$refs.placeAndEquipmentRef.getFieldsAndDevicePlaybackFn({
              code: this.form.bidCode,
              roomType: this.openBidWitness_dataTypeObj.bidOpening,// 8:专家抽取室  1:开标室  2:评标室
              bizType: 'bid',// 业务分组 bid 或者 project
              deviceType: '', // 1桌面  2 摄像头
              tradeOrgId: '' // 交易中心id
            })
          }
        })
      } else {
        tabsCloseCurrentHandle()
        this.$router.push({
          name: 'openBidAndEstimateWitness_list'
        })
      }

    },


  },


}
</script>

<style lang="scss" scoped>
.processStatus {
  position: absolute;
  right: 20px;
  top: 20px;

  img {
    opacity: 0.5;
  }
}

.monitor-video {
  width: 100%;
  padding: 24px;
  background: #001F39;
  border-radius: 2px;
  display: inline-block;
  box-sizing: border-box;
  position: relative;

  .monitor-video-list {
    position: relative;
    display: inline-block;
    width: calc(70% - 16px);
    height: 682px;
    margin-right: 16px;

  }

  .screenshot {
    position: absolute;
    top: 44%;
    right: 48px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.25);
    text-align: center;
    padding-top: 14px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.65);
    padding: 0;

    .sereen-text {
      display: block;
      font-size: 16px;
    }
  }

  .screenshot:hover {
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
  }

  .screenshot-ie {
    position: absolute;
    bottom: -6%;
    right: 0;
    width: 75px;
    height: 32px;
    line-height: 32px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 2px;
    text-align: center;
    // padding-top:14px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.65);
    padding: 0;

    .screen-img {
      vertical-align: text-bottom;
    }

    .sereen-text {
      font-size: 16px;
    }
  }

  .screenshot-ie:hover {
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
  }
}

.monitor-video-ie {
  height: 770px
}

.open-bid-detail-form {
  margin: 20px;

  .btn {
    text-align: center;
  }
}


.viewImg {
  height: 100%;
  display: block;
  margin: 0 auto;
}

.main_center {

  /deep/ .el-dialog__header {
    border-bottom: 0;
  }

  /deep/ .el-dialog__body {
    padding: 0 10px 20px 10px;
  }




}


.thumbnail {
  width: 50px;
  height: 50px;
}
</style>